module.exports = __webpack_public_path__ + "static/media/Report-card-game.717b41d6.png";